module.exports = __webpack_public_path__ + "static/media/img_tv.c53b995e.svg";